"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M21.863.275c.396.28.634.74.634 1.225v16.003a.498.498 0 0 1-.032.178l-.023-.103c.13.512.036 1.053-.27 1.563-.478.795-1.436 1.435-2.562 1.71a5.036 5.036 0 0 1-1.199.15c-1.424 0-2.585-.657-2.856-1.727-.128-.512-.035-1.053.271-1.563.478-.795 1.436-1.435 2.562-1.71 1.195-.295 2.335-.14 3.11.344V5.21l-13 4.642.002 11.162a2.14 2.14 0 0 1-.327 1.126c-.478.795-1.436 1.435-2.562 1.711A5.03 5.03 0 0 1 4.412 24c-1.424 0-2.584-.657-2.855-1.727-.13-.512-.036-1.053.27-1.563.479-.794 1.436-1.434 2.562-1.71 1.197-.294 2.336-.139 3.11.345V5.785c0-.631.4-1.199.996-1.412L20.494.088c.458-.165.97-.094 1.369.187ZM5.58 19.853a4 4 0 0 0-.952.118c-.86.21-1.604.692-1.943 1.254-.116.193-.238.49-.158.803.2.792 1.504 1.184 2.847.852.86-.21 1.604-.692 1.943-1.255.116-.193.238-.49.158-.802-.153-.6-.94-.97-1.895-.97Zm13.998-3a4 4 0 0 0-.952.118c-.86.211-1.604.692-1.943 1.255-.116.193-.238.49-.158.803.2.792 1.504 1.184 2.847.852.86-.211 1.604-.692 1.943-1.255.116-.193.238-.49.158-.803-.153-.6-.94-.97-1.895-.97Zm1.25-15.824L8.832 5.314a.503.503 0 0 0-.331.472V8.79l12.997-4.641V1.5a.495.495 0 0 0-.211-.409.497.497 0 0 0-.457-.062Z",
    clipRule: "evenodd"
  })]
});